const PEER_CONFIG = {
  host: process.env.VUE_APP_SIGNALING_HOST,
  port: process.env.VUE_APP_SIGNALING_PORT,
  secure: process.env.NODE_ENV !== 'development',
  iceServers: [
    { 'urls': 'stun:18.177.204.231:80' },
    { 'urls': 'turn:18.177.204.231:80?transport=tcp', 'username': 'ice-miteme','credential': 'Gp~Pekam9g2-h7cZ' }
  ]
}

export default PEER_CONFIG
